import { render, staticRenderFns } from "./IM01.vue?vue&type=template&id=4d3d5820&"
import script from "./IM01.vue?vue&type=script&lang=js&"
export * from "./IM01.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports